module.exports = function (key, context) {
  const value = context[key];
  const simpleNumber = require("./simpleNumber");
  return simpleNumber(value);
};
